"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ButtonTs = _interopRequireDefault(require("@lt/components/components/ButtonTs"));

var _Loader = _interopRequireDefault(require("@lt/components/icons-react/rebrand/Loader"));

var _context = require("../../context");

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var SearchButton = function SearchButton(props) {
  var loading = props.loading,
      shouldDisplay = props.shouldDisplay,
      isHotelVariantButton = props.isHotelVariantButton;

  var _useCigarette = (0, _context.useCigarette)(),
      _useCigarette$state = _useCigarette.state,
      isWizard = _useCigarette$state.isWizard,
      isMobile = _useCigarette$state.isMobile,
      steps = _useCigarette$state.steps;

  if (isWizard && !(0, _utils.isTouristsStep)(steps) && !shouldDisplay) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
    $isMobile: isMobile,
    $isWizard: isWizard,
    $isHotelVariantButton: isHotelVariantButton
  }, /*#__PURE__*/_react["default"].createElement(SubmitButton, {
    type: "submit",
    variant: "primary",
    $isMobile: isMobile,
    $isWizard: isWizard,
    $isHotelVariantButton: isHotelVariantButton
  }, loading ? /*#__PURE__*/_react["default"].createElement(StyledLoaderIcon, null) : 'Найти'));
};

exports.SearchButton = SearchButton;

var ButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearchButton__ButtonContainer",
  componentId: "sc-134rj27-0"
})(["display:flex;align-items:center;align-self:stretch;", ";border-radius:0 var(--border-radius) var(--border-radius) 0;margin-left:auto;position:relative;", ""], function (_ref) {
  var $isHotelVariantButton = _ref.$isHotelVariantButton,
      $isMobile = _ref.$isMobile;
  return $isMobile ? "background-color: var(--white)" : "background-color: ".concat($isHotelVariantButton ? "var(--secondary)" : "var(--secondary-header)");
}, function (_ref2) {
  var $isMobile = _ref2.$isMobile,
      $isWizard = _ref2.$isWizard;
  return $isMobile && (0, _styledComponents.css)(["width:100%;margin-top:auto;order:1;padding:", ";border-radius:var(--border-radius);", ""], $isWizard ? '8px' : '0', $isWizard && (0, _styledComponents.css)(["position:fixed;bottom:0;z-index:1;"]));
});

var SubmitButton = (0, _styledComponents["default"])(_ButtonTs["default"]).withConfig({
  displayName: "SearchButton__SubmitButton",
  componentId: "sc-134rj27-1"
})(["&&{", " height:100%;width:150px;font-size:18px;font-style:normal;font-weight:500;line-height:22px;", ";", ";}"], function (_ref3) {
  var $isHotelVariantButton = _ref3.$isHotelVariantButton;
  return !$isHotelVariantButton && "--background-color: var(--secondary-header);\n      background-color: var(--background-color);\n      color: var(--secondary-header-color);\n      ";
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile,
      $isWizard = _ref4.$isWizard;
  return !$isMobile && !$isWizard && (0, _styledComponents.css)(["border-radius:0 var(--border-radius) var(--border-radius) 0;"]);
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["height:48px;width:100%;font-size:16px;line-height:20px;"]);
});
var StyledLoaderIcon = (0, _styledComponents["default"])(_Loader["default"]).withConfig({
  displayName: "SearchButton__StyledLoaderIcon",
  componentId: "sc-134rj27-2"
})(["height:30px;animation:var(--loader-animation);path{fill:var(--white);}"]);